<div class="search" *transloco="let t; read:'knowledgeBank.search.results'">
    <knowledge-bank-search-box [isMain]="true"></knowledge-bank-search-box>

    <knowledge-bank-search-results></knowledge-bank-search-results>
</div>
